import {generateSeoInfo} from '../../modules/seo/seoUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

function generateDefaultInitialBrandState() {
  return {
    brandSeoInfo: null,
    brandProductArray: null,
    brandBreadCrumbArray: null,
    brandProductPaginationParams: {
      pageNumber: 1,
    },
    totalBrandProductCount: 0,
    brandSearchPass: null,
    brandSearchContext: null,
    brandInfo: null,
    hasBrand: null,
    brand_id:null,
    onlyProducts: true,
    defaultTab: null,
    cardType: null,
  };
}

function brandReducer(state = generateDefaultInitialBrandState(), action) {
  let newState;
  switch (action.type) {
    case 'GET_BRAND_PRODUCTS_FULFILLED': {
      const {
        products,
        breadcrumbs,
        totalProductCount,
        seoInformation: rawSeoInformation,
        searchPass,
        searchContext,
        similarCategories,
        cardType,
      } = action.payload.response.data.data;

      const seoInformationData = generateSeoInfo(rawSeoInformation);

      newState = {
        ...state,
        brandProductArray: products,
        totalBrandProductCount: totalProductCount,
        brandBreadcrumbArray: breadcrumbs,
        brandShippingType: seoInformationData ? seoInformationData.utagData.shipping_type : '',
        brandSeoInfo: seoInformationData,
        brandSearchPass: searchPass,
        brandProductPaginationParams: {
          ...state.brandProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        initialPageNumber: action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE],
        brandSearchContext: searchContext,
        similarCategories,
        cardType,
      };

      break;
    }

    case 'GET_NEXT_BRAND_PRODUCTS_FULFILLED': {
      const {
        products,
        totalProductCount,
        seoInformation: rawSeoInformation,
        cardType,
      } = action.payload.response.data.data;
      const seoInformationData = generateSeoInfo(rawSeoInformation);

      newState = {
        ...state,
        brandProductArray: state.brandProductArray.concat(
          products
        ),
        totalBrandProductCount: totalProductCount,
        brandShippingType: state.brandShippingType.concat(
          seoInformationData ? seoInformationData.utagData.shipping_type : '',
        ),
        brandSeoInfo: generateSeoInfo({
          ...rawSeoInformation,
          h2: state.brandSeoInfo.h2,
          seoParagraph: state.brandSeoInfo.seoParagraph,
        }),
        brandProductPaginationParams: {
          ...state.brandProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        cardType
      };

      break;
    }

    case 'GET_BRAND_INFO_FULFILLED': {
      const {
        brand,
        hasBrand,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        brandInfo: brand,
        hasBrand,
      };

      break;
    }
    case 'GET_BRAND_BY_NAME_FULFILLED':{
      const {
        id,
        status,
        isSuspended
      } = action.payload.response.data;
      newState = {
        ...state,
        brand_id:id,
        onlyProducts: (status !== 'Active') || (isSuspended === true),
      }
      break
    }
    case 'SET_BRAND_DEFAULT_TAB': {
      const defaultTab = action.payload;

      newState = {
        ...state,
        defaultTab,
      };

      break;
    }

    case 'GET_SIMILAR_BRANDS_FULFILLED':{
      const similarBrands = action.payload.response.data.data ?? [];
      
      newState = {
        ...state,
        similarBrands,
      }

      break;
    }

    case 'LEAVE_BRAND_PAGE_ROUTE': {
      newState = {
        ...state,
        brandProductArray: null,
        brandSeoInfo: null,
        brandProductPaginationParams: {
          pageNumber: 1,
        },
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default brandReducer;
export {generateDefaultInitialBrandState};
